import React from 'react';
import { ThemeProvider } from './src/context/ThemeContext';
import './src/styles/global.css';
import 'prismjs/themes/prism-tomorrow.css';

export const wrapRootElement = ({
  element,
}: {
  element: React.ReactElement;
}) => <ThemeProvider>{element}</ThemeProvider>;
